"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Mapmarker;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Mapmarker(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "mapmarker"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,92.5a4.526,4.526,0,0,1-3.224-1.333,2.513,2.513,0,0,1-.423-.565L24.668,51.046c-.169-.3-.355-.63-.532-.971l-.249-.453a2.475,2.475,0,0,1-.2-.476,28.832,28.832,0,0,1-2.84-12.493,29.153,29.153,0,0,1,58.306,0,28.848,28.848,0,0,1-2.859,12.534,2.313,2.313,0,0,1-.181.435l-.275.5c-.151.292-.337.626-.526.959L53.647,90.6a2.523,2.523,0,0,1-.424.566A4.529,4.529,0,0,1,50,92.5ZM28.437,47.522l.11.2c.173.332.327.609.485.885L50,86.854,70.947,48.643c.179-.313.333-.59.48-.873l.135-.246a2.513,2.513,0,0,1,.114-.274,23.9,23.9,0,0,0,2.477-10.6,24.153,24.153,0,0,0-48.306,0,23.9,23.9,0,0,0,2.477,10.6A2.475,2.475,0,0,1,28.437,47.522Zm45.484.9h0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,49.537a12.2,12.2,0,1,1,12.2-12.2A12.215,12.215,0,0,1,50,49.537Zm0-19.4a7.2,7.2,0,1,0,7.2,7.2A7.209,7.209,0,0,0,50,30.135Z"
  })))));
}